import Route from '@ember/routing/route';

export default class AppHelpRoute extends Route {}
